// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92666a4a","453":"f98a6fde","732":"017b716a","977":"6ee3c74c"}[chunkId] + ".chunk.js";
};